// extracted by mini-css-extract-plugin
module.exports = {"slidesList":"_71aa134485783d50a66d18137b89a2d3-less","slideItem":"_4938a2e40f10872ae444e19a41afab53-less"};